module.exports = __webpack_public_path__ + "static/media/stairs-white3.b806f09b.png";